<template>
  <div>
    <div class="hero delkoithts-bg">
      <div class="inner">
        <h1>DELKOIT HTS</h1>
        <h5 class="subtitle">Trading platform for brokers offering stocks, options, futures</h5>
        <div class="hero-btn-container" @click="goContact">
          <BtnPrimary text="Request a Demo" />
        </div>
      </div>
    </div>
		<section class="section3 light-gray">
			<div class="section-inner">
				<h2 class="section-title">
          {{$t('delkoitHTSPage.text1')}}
        </h2>
				<div class="col2-grid">
					<div class="col2-grid-item">
						<img src="@/assets/icons/hts-icon8.png" alt="">
						<div class="right">
							<div class="title">
{{$t('delkoitHTSPage.text2')}}
              </div>
							<div class="subtitle">
{{$t('delkoitHTSPage.text3')}}								
							</div>
						</div>
					</div>
					<div class="col2-grid-item">
						<img src="@/assets/icons/hts-icon9.png" alt="">
						<div class="right">
							<div class="title">
{{$t('delkoitHTSPage.text4')}}
              </div>
							<div class="subtitle">
								{{$t('delkoitHTSPage.text5')}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
    <section class="section3">
      <div class="section-inner">
				<img class="hts-image" src="@/assets/images/hts-image1.png" alt="">
        <h2 class="section-title">{{$t('delkoitHTSPage.text6')}}</h2>
        <p class="center" v-html="$t('delkoitHTSPage.text7')">
        </p>
        <div class="spacer"></div>
        <div class="col4-grid center">
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/tap-icon1.svg" alt="" /></div>
            <h5>{{$t('delkoitHTSPage.text8')}}</h5>
            <p v-html="$t('delkoitHTSPage.text9')">
            </p>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/tap-icon2.svg" alt="" /></div>
            <h5>{{$t('delkoitHTSPage.text10')}}</h5>
            <p>{{$t('delkoitHTSPage.text11')}}</p>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/tap-icon3.svg" alt="" /></div>
            <h5>{{$t('delkoitHTSPage.text12')}}</h5>
            <p>{{$t('delkoitHTSPage.text13')}}</p>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/tap-icon4.svg" alt="" /></div>
            <h5>{{$t('delkoitHTSPage.text14')}}</h5>
            <p>{{$t('delkoitHTSPage.text15')}}</p>
          </div>
        </div>
      </div>
    </section>
    <section class="dark">
      <div class="section-inner">
        <h2 class="section-title">{{$t('delkoitHTSPage.text16')}}</h2>
        <div class="spacer"></div>
        <div class="col3-grid center">
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/hts-icon1.svg" alt="" /></div>
            <h5 class="opacity">{{$t('delkoitHTSPage.text17')}}</h5>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/hts-icon2.svg" alt="" /></div>
            <h5 class="opacity">{{$t('delkoitHTSPage.text18')}}</h5>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/hts-icon3.svg" alt="" /></div>
            <h5 class="opacity">{{$t('delkoitHTSPage.text19')}}</h5>
          </div>
        </div>
      </div>
    </section>
    <section class="section3">
      <div class="section-inner">
        <h2 class="section-title">{{$t('delkoitHTSPage.text20')}}</h2>
        <p>{{$t('delkoitHTSPage.text21')}}</p>
      </div>
    </section>
    <section class="section3 light-gray">
      <div class="section-inner">
        <h2 class="section-title">{{$t('delkoitHTSPage.text22')}}</h2>
        <p>{{$t('delkoitHTSPage.text23')}}</p>
        <router-link to="contact" class="contact-us"><BtnPrimary text="Contact us" /></router-link>
      </div>
    </section>
  </div>
</template>

<script>
import BtnPrimary from '@/components/BtnPrimary.vue';

export default {
  name: 'DelkoitHtsPage',
  components: { BtnPrimary },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    goContact() {
      this.$router.push('contact')
    }       
  },
};
</script>

<style lang="scss" scoped></style>
